import { database } from './firebase.js';

export async function getEntries() {
  const entries = await database.ref(`events`).once('value');
  const obj = entries.val();
  const list = [];
  for (let key in obj) {
    list.push(normalizeEntry(obj[key]))
  }

  return list
}

export async function getEntry(id) {
  let entry = await database.ref(`events/${id}`).once('value');

  if (!entry.val()) return null;
  return normalizeEntry(entry.val())
}

function normalizeEntry(entry) {
  entry.date = new Date(entry.date);
  entry.tags = entry.tags || [];
  entry.liked_users = entry.liked_users || [];

  return entry
}

export async function uploadNewEvent(newEvent) {
  const myRef = database.ref('events/').push();
  newEvent.id = myRef.key;

  if (!newEvent.channel) delete newEvent.channel;
  newEvent.date = newEvent.date && newEvent.date._d && newEvent.date._d.toISOString();

  newEvent.uStreamChatUrl = newEvent.channel && `https://www.ustream.tv/socialstream/${newEvent.channel.id}`;
  newEvent.uStreamUrl = newEvent.channel && `https://www.ustream.tv/embed/${newEvent.channel.id}?html5ui&autoplay=true`;

  try {
    const setIn = await myRef.set(newEvent);
    return {eventId: myRef.key}
  } catch(error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export function updateExistingEvent(event, eventType) {
  if (!event.channel) delete event.channel;
  const dateISOSType = event.date && new Date(event.date);

  event.date = dateISOSType.toISOString();
  event.isContributor = false;
  event.notificationSent = eventType === 'past';

  return database.ref(`events/${event.id}`).set(event)
}

export async function deleteEventVideo(event, type) {
  const dateISOSType = event.date && new Date(event.date);
  event.date = dateISOSType.toISOString();
  event[type] = {};

  return await database.ref(`events/${event.id}`).update(event)
    .then(() => { return 'success' })
    .catch((error) => { return error })
}

export async function deleteEvent(event) {
  await database.ref(`events/${event.id}`).remove();

  return 'success'
}



// WEBPACK FOOTER //
// ./src/services/firebase/events.js